import { logDebug } from "../utils/logger";

/**
 * Envia notificações via OneSignal para uma lista de usuários (ids Sponte).
 *
 * Obs: hoje o app já usa a tag `idSponte` no OneSignal, então a abordagem
 * mais simples e segura é enviar UMA notificação por usuário, usando filters.
 * Mantemos a implementação simples para não quebrar o fluxo atual.
 */
export const sendOneSignalNotifications = async ({ name, unit, ids, message }) => {
  // Nada para enviar
  if (!ids || ids.length === 0) {
    logDebug("[OneSignal] Nenhum destinatário para notificação");
    return [];
  }

  // Normalizar IDs (número -> string, remover duplicados/vazios)
  const uniqueIds = Array.from(
    new Set(
      ids
        .filter((id) => id !== null && id !== undefined)
        .map((id) => id.toString())
    )
  );

  if (uniqueIds.length === 0) {
    logDebug("[OneSignal] Lista de destinatários vazia após normalização");
    return [];
  }

  const sendToUser = async (idSponte) => {
    const requestBody = {
      app_id: "31860986-7f49-44ac-8552-84fd749ee8fb",
      name: name || undefined,
      headings: { en: name || "" },
      contents: { en: message || "" },
      filters: [
        {
          field: "tag",
          key: "idSponte",
          relation: "=",
          value: String(idSponte),
        },
        {
          field: "tag",
          key: "unit",
          relation: "=",
          value: String(unit || ''),
        },
      ],
      isAnyWeb: false,
      isAndroid: true,
      isIos: true,
    };

    const options = {
      method: "POST",
      headers: {
        accept: "application/json",
        Authorization: "Basic OTg5NzU1NGUtZGNhYS00NWQ1LThmNGItYWY0MmUxZmIwOTFi",
        "content-type": "application/json",
      },
      body: JSON.stringify(requestBody),
    };

    try {
      const response = await fetch(
        "https://onesignal.com/api/v1/notifications",
        options
      ).then((res) => res.json());

      logDebug("[OneSignal] Resposta para usuário:", {
        idSponte,
        response,
      });

      if (response.errors || response.error) {
        const errorMessage = JSON.stringify(response.errors || response.error);
        throw new Error(errorMessage);
      }

      return { idSponte, success: true, response };
    } catch (err) {
      console.error("[OneSignal] Erro ao enviar para usuário:", idSponte, err);
      return {
        idSponte,
        success: false,
        error: err?.message || String(err),
      };
    }
  };

  const results = [];
  const batchSize = 30; // número de usuários por lote (ajusta paralelismo)

  // Envia em lotes para reduzir o tempo total sem sobrecarregar a rede
  for (let i = 0; i < uniqueIds.length; i += batchSize) {
    const batch = uniqueIds.slice(i, i + batchSize);

    // Enviar esse lote em paralelo
    // Cada sendToUser já trata o próprio erro e sempre resolve com { success: true/false }
    // então podemos usar Promise.all com segurança.
    // eslint-disable-next-line no-await-in-loop
    const batchResults = await Promise.all(batch.map((id) => sendToUser(id)));
    results.push(...batchResults);
    }

  return results;
};

